import { useRating } from '@risksmart-app/components/src/hooks/useRating';
import type { ContentTable } from 'pdfmake/interfaces';
import type { GetStandardFormFieldLabel } from 'src/hooks/forms/useFormCustomisation';

import { useLazyGetAcceptancesByParentRiskId } from '@/hooks/queries';
import { toLocalDate } from '@/utils/dateUtils';
import { createTable, tableHeaders } from '@/utils/pdf/table';

const useAcceptancesExportTable = (
  riskId: string,
  getStandardFieldLabel: GetStandardFormFieldLabel
): [() => Promise<ContentTable>, boolean] => {
  const { getLabel: getStatusLabel } = useRating('acceptance_status');
  const [getAcceptances, getAcceptancesResult] =
    useLazyGetAcceptancesByParentRiskId();

  const createExportTable = async () => {
    const { data: appetiteData } = await getAcceptances({ riskId });
    const acceptanceTableData = (appetiteData?.acceptance ?? []).map((i) => [
      i.Title,
      i.Details ?? '',
      toLocalDate(i.DateAcceptedFrom),
      toLocalDate(i.DateAcceptedTo),
      getStatusLabel(i.Status),
    ]);

    return createTable({
      widths: '*',
      body: [
        tableHeaders([
          getStandardFieldLabel('acceptance', 'Title'),
          getStandardFieldLabel('acceptance', 'Details'),
          getStandardFieldLabel('acceptance', 'DateAcceptedFrom'),
          getStandardFieldLabel('acceptance', 'DateAcceptedTo'),
          getStandardFieldLabel('acceptance', 'Status'),
        ]),
        ...acceptanceTableData,
      ],
    });
  };

  return [createExportTable, getAcceptancesResult.loading];
};

export default useAcceptancesExportTable;
